import { InfiniteTable } from '@/components/_common';
import {
  useCustomerAddresses,
  useUpdateCustomerAddress,
} from '@/core/domain/people/CustomerAddresses/CustomerAddresses.hooks';
import {
  CustomerAddress,
  UpdateCustomerAddressRequest,
} from '@/core/domain/people/CustomerAddresses/CustomerAddresses.types';
import { removeMask } from '@/utils/mask';
import { getTableScrollX } from '@/utils/table';
import { Modal, ModalProps } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props extends ModalProps {
  customerId?: number;
  onCancel: VoidFunction;
}

const CustomerSetMainAddressModal: React.FC<Props> = ({
  customerId,
  ...props
}) => {
  const { data, isLoading } = useCustomerAddresses(customerId);
  const [addressSelectKey, setAddressSelectKey] = useState<
    number | undefined
  >();

  const defineMainAddressMutation = useUpdateCustomerAddress(customerId);

  const handleOk = async () => {
    if (data?.data.length && addressSelectKey) {
      const address = data.data.find((item) => item.id === addressSelectKey);

      if (address) {
        const obj: UpdateCustomerAddressRequest = {
          ...address,
          zipCode: removeMask(address.zipCode),
          main: true,
        };

        await defineMainAddressMutation.mutateAsync(obj);

        if (props.onCancel) {
          props.onCancel();
        }
      }
    }
  };

  const columns: ColumnsType<CustomerAddress> = [
    {
      dataIndex: 'description',
      title: <FormattedMessage id="customers.domain.address.description" />,
      width: 250,
    },
    {
      dataIndex: 'street',
      title: <FormattedMessage id="customers.domain.address.street" />,
      render: (_, row) => `${row.street}, ${row.number} - ${row.district}`,
      width: 250,
    },
  ];

  return (
    <Modal
      {...props}
      width={900}
      title="Definir endereço principal"
      okButtonProps={{ disabled: !addressSelectKey }}
      onOk={handleOk}
      confirmLoading={defineMainAddressMutation.isLoading}
      okText="Salvar"
    >
      <InfiniteTable<CustomerAddress>
        columns={columns}
        dataSource={data?.data}
        loading={isLoading}
        rowKey={(row) => row.id}
        scroll={{ x: getTableScrollX(columns) }}
        rowSelection={{
          columnWidth: 100,
          columnTitle: 'Principal',
          type: 'radio',
          selectedRowKeys: [addressSelectKey as React.Key],
          onChange: (keys) => setAddressSelectKey(keys[0] as number),
        }}
      />
    </Modal>
  );
};

export default CustomerSetMainAddressModal;
